import { getClient } from '@api/client';
import { fragment } from '@api/fragment';
import { graphql } from '@api/generated';
import ServiceQueue from '../types/ServiceQueue';
import {
  serviceQueueFieldsFragment,
  serviceQueueStatsFragment,
} from './serviceQueueFragment';

const getServiceQueuesQuery = graphql(`
  query getServiceQueuesQuery($skipStats: Boolean = true) {
    queues {
      items {
        ...ServiceQueueFields
        ...ServiceQueueStats @skip(if: $skipStats)
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`);

async function getServiceQueues(fetchStats = false): Promise<ServiceQueue[]> {
  const { data, error } = await getClient().query({
    query: getServiceQueuesQuery,
    fetchPolicy: 'network-only',
    variables: { skipStats: !fetchStats },
  });

  if (error) {
    throw new Error(error.message);
  }

  const items = data?.queues?.items ?? [];

  return items.map((item) => {
    const base = fragment(serviceQueueFieldsFragment, item);
    const stats = fragment(serviceQueueStatsFragment, item);
    return structuredClone({
      ...base,
      status: stats?.status ?? {},
    }) as ServiceQueue;
  });
}

export default getServiceQueues;
